var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckboxCircleActual(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4999 19.997C16.0214 19.997 20.4974 15.5209 20.4974 9.99945C20.4974 4.47799 16.0214 0.00195312 10.4999 0.00195312C4.97847 0.00195312 0.502441 4.47799 0.502441 9.99945C0.502441 15.5209 4.97847 19.997 10.4999 19.997Z",
    fill: "#EDF4FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4999 19.4408C15.7147 19.4408 19.942 15.2134 19.942 9.99872C19.942 4.784 15.7147 0.556641 10.4999 0.556641C5.28523 0.556641 1.05786 4.784 1.05786 9.99872C1.05786 15.2134 5.28523 19.4408 10.4999 19.4408Z",
    stroke: "#293990"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.65454 10.8457L8.34791 12.5397L13.8869 7",
    stroke: "#293990",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxCircleActual);
export default __webpack_public_path__ + "static/media/checkbox-circle-actual.c7f1c6b6aa373ff6c8d9f228fdaae9c7.svg";
export { ForwardRef as ReactComponent };